import { Table } from 'dexie'
import { DB_NAME_GLOBAL, IndexDbService } from './indexDb.service'

export interface ILocation {
  id: string
  nemsisCode: string
  zipCode: number
  city: string
  state: string
  county: string
}

export type Locations = Array<ILocation>

export type GlobalData = Array<IGlobalDataDoc>

export interface IGlobalDataDoc {
  [key: string]: any // key can be rules, entity
}

export interface IGlobalDataDocMetadata {
  id: string
  lastUpdatedTime: string
  docGroup: string
  dataSize: string
}

export class GlobalIndexDbService extends IndexDbService {
  locations!: Table<Locations, string>
  metadataDataStore!: Table<IGlobalDataDocMetadata, string>
  globalData!: Table<IGlobalDataDoc, string>

  constructor() {
    super(DB_NAME_GLOBAL)

    this.db.version(3).stores({
      locations: 'id,[state+city],state',
    })

    this.db.version(2).stores({
      globalData: 'id',
    })

    this.db.version(1).stores({
      locations: 'id,[state+city]',
      metadataDataStore: 'id,docGroup',
    })

    // Instantiate all tables here
    this.locations = this.db.table('locations')
    this.metadataDataStore = this.db.table('metadataDataStore')
    this.globalData = this.db.table('globalData')

    this.db.open()
  }
}
